export function setTemplateFilters(state) {
  if (!state.template_filters) return
  localStorage.setItem('template_filters', JSON.stringify(state.template_filters))
}

export function getTemplateFilters() {
  const filters = localStorage.getItem('template_filters') || "{}"
  return { template_filters: JSON.parse(filters) }
}
